module.exports = __webpack_public_path__ + "static/media/21.65e38dae.mp3";